module.exports = __webpack_public_path__ + "img/selected0-min.3a9746f2.png";